import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { StorageService } from '../../shared/services/storage.service';
import { ResponseModel } from '../../shared/models/response-model.model';
import {PaymentVoucherList, PaymentVoucherModel, ReceiptVoucherModel, VoucherModel} from './transaction.model'
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(public service: DataService,public storageService: StorageService) {}

  insertPaymentVoucher(data:PaymentVoucherModel){
    let url = `api/App/Voucher/insertPaymentVoucher`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  updatePaymentVoucher(data:PaymentVoucherModel){
    let url = `api/App/Voucher/updatePaymentVoucher`;
    return this.service.putWithId(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  deletePaymentVoucherDetails(id){
    let url = `api/App/Voucher/deletePaymentVoucherDetails?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  insertReceiveVoucher(data:ReceiptVoucherModel){
    let url = `api/App/Voucher/insertReceiptVoucher`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  updateReceiveVoucher(data:ReceiptVoucherModel){
    let url = `api/App/Voucher/updateReceiptVoucher`;
    return this.service.putWithId(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllPaymentVoucher(data:PaymentVoucherList){
    let url = `api/App/Voucher/getTransactionHistoryByCustomerId`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllReceiveVoucher(data:PaymentVoucherList){
    let url = `api/App/Voucher/GetAllReceiptVoucher`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteReceiptVoucherDetails(id){
    let url = `api/App/Voucher/deleteReceiptVoucherDetails?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  deletepdcvoucher(id:any,pdcVoucherTypeId:any)
  {
    let url =`api/app/pdcvoucher/deletepdcvoucher?Id=${id}&PDCVoucherType=${pdcVoucherTypeId}`
    return this.service.delete(url,true).pipe<ResponseModel>( tap((response: any) => {
    return response;}))
  }

  deletePaymentVoucher(id){
    let url = `api/App/Voucher/deletePaymentVoucher?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteReceiveVoucher(id){
    let url = `api/App/Voucher/deleteReceiptVoucher?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  getVoucherNumber(){
    let url = `api/App/Voucher/getVoucherNumber`;
    return this.service.get(url).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }
}
